import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['isLayoutReady'])
  },
  watch: {
    isLayoutReady: {
      async handler(dashboardReady) {
        if (dashboardReady && this.onLayoutReady) {
          // will only run if it finds a method on the page called onLayoutReady
          this.$nextTick(() => {
            this.onLayoutReady();
          });
        }
      },
      immediate: true
    }
  }
};
